import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import TargetTitle from '@/types/table/targetTitle';
import { TargetItemData } from '@/api/generated/targetItemController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface TargetTitleData extends TargetTitle {
  targetItemList?: TargetItemData[];
  targetItem?: TargetItemData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class TargetTitleController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<TargetTitleData>>(
      API_CONTEXT + '/upms/targetTitle/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<TargetTitleData>(API_CONTEXT + '/upms/targetTitle/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/targetTitle/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/targetTitle/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/targetTitle/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/targetTitle/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/targetTitle/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/targetTitle/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/targetTitle/deleteBatch', params, httpOptions);
  }
}
